import {
  GET_PARTNERS_LIST,
  GET_PARTNERS_LIST_SUCCESS,
  GET_PARTNERS_LIST_FAILURE,
} from "./actionType";

const initialState = {
  partnersList: [],
  partnersListLoading: false,
  partnersListError: null,
};

const Partners = (state = initialState, action) => {
  switch (action.type) {
    case GET_PARTNERS_LIST:
      return {
        ...state,
        partnersListLoading: true,
        partnersListError: null,
      };
    case GET_PARTNERS_LIST_SUCCESS:
      return {
        ...state,
        partnersList: action.payload,
        partnersListLoading: false,
        partnersListError: null,
      };
    case GET_PARTNERS_LIST_FAILURE:
      return {
        ...state,
        partnersList: [],
        partnersListLoading: false,
        partnersListError: action.payload,
      };
    default:
      return state;
  }
};

export default Partners;
